__turbopack_context__.v({
  "accordionSlideOverwrite": "organization-summary-module-scss-module__oJKVZW__accordionSlideOverwrite",
  "badge": "organization-summary-module-scss-module__oJKVZW__badge",
  "badgeList": "organization-summary-module-scss-module__oJKVZW__badgeList",
  "fadeIn": "organization-summary-module-scss-module__oJKVZW__fadeIn",
  "fadeOut": "organization-summary-module-scss-module__oJKVZW__fadeOut",
  "scaleIn": "organization-summary-module-scss-module__oJKVZW__scaleIn",
  "scaleOut": "organization-summary-module-scss-module__oJKVZW__scaleOut",
  "summary": "organization-summary-module-scss-module__oJKVZW__summary",
  "title": "organization-summary-module-scss-module__oJKVZW__title",
  "zoomIn": "organization-summary-module-scss-module__oJKVZW__zoomIn",
  "zoomOut": "organization-summary-module-scss-module__oJKVZW__zoomOut",
});
